import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { orderService } from '../services/api';
import { FaEye, FaArrowLeft } from 'react-icons/fa';

const OrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setLoading(true);
        const response = await orderService.getUserOrders();
        setOrders(response.data);
      } catch (error) {
        console.error('Error fetching orders:', error);
        setError('Failed to load your orders. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  // Get status badge class based on order status
  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'processing':
        return 'bg-primary-color';
      case 'shipped':
        return 'bg-accent-color';
      case 'delivered':
        return 'bg-success-color';
      case 'cancelled':
        return 'bg-danger-color';
      default:
        return 'bg-secondary-color';
    }
  };

  if (loading) {
    return (
      <div className="container py-4">
        <div className="text-center">
          <p>Loading your orders...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-4">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">My Orders</h1>
        <Link to="/profile" className="flex items-center text-primary-color">
          <FaArrowLeft className="mr-2" /> Back to Profile
        </Link>
      </div>

      {error && (
        <div className="alert alert-error mb-4">
          <p>{error}</p>
        </div>
      )}
      
      {orders.length === 0 ? (
        <div className="card p-8 text-center">
          <h2 className="text-xl mb-4">You haven't placed any orders yet</h2>
          <p className="mb-4">Start shopping to see your orders here.</p>
          <Link to="/products" className="btn btn-primary">
            Browse Products
          </Link>
        </div>
      ) : (
        <div className="card">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-light-gray">
                  <th className="text-left py-2">Order #</th>
                  <th className="text-left py-2">Date</th>
                  <th className="text-left py-2">Total</th>
                  <th className="text-left py-2">Status</th>
                  <th className="text-right py-2">Actions</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((order) => (
                  <tr key={order.id} className="border-b border-light-gray">
                    <td className="py-4">#{order.id}</td>
                    <td className="py-4">{new Date(order.created_at).toLocaleDateString()}</td>
                    <td className="py-4">${parseFloat(order.total_amount).toFixed(2)}</td>
                    <td className="py-4">
                      <span className={`${getStatusBadgeClass(order.status)} text-white text-sm py-1 px-2 rounded-full`}>
                        {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
                      </span>
                    </td>
                    <td className="py-4 text-right">
                      <Link 
                        to={`/orders/${order.id}`}
                        className="btn btn-sm btn-primary flex items-center gap-1 inline-flex justify-content-end"
                      >
                        <FaEye /> View
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrdersPage; 